module.exports = __webpack_public_path__ + "static/img/best_makeup_hair_block_6.cec7d9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best_makeup_hair_block_6.jpg
// module id = 261
// module chunks = 0